<template>
  <div class="badge" :class="[badgeVariant]" v-bind="$attrs">
    <img v-if="icon" src="/media/inpulse-template-ac-new-a/profile/checked.svg" alt="checked">
    <slot />
  </div>
</template>

<script>
export default {
  name: "AppBadge",

  props: ["type", "icon"],

  data() {
    return {

    };
  },

  computed: {
    badgeVariant() {
      switch (this.type) {
        case "success": return 'badge_success';
        case "danger": return 'badge_danger';
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.badge
  display: inline-flex
  white-space: nowrap
  align-items: center
  font-size: 0.875rem
  line-height: 1.25rem
  font-weight: 500
  color: rgba(197, 197, 197, 1)
  padding: 4px 8px
  border-radius: 39px

  &.badge_success
    border: 1px solid rgba(20, 254, 0, 1)

  &.badge_danger
    border: 1px solid rgba(254, 0, 0, 1)

  img
    margin-right: 4px
</style>